<div class="stick-top">
  <mat-toolbar>
    <mat-icon>category</mat-icon> Secure Access Categories
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/access/categories/0" [disabled]="!auth.hasRole('COMPANY_ADMIN')">
      <mat-icon>add</mat-icon>
      Create new Access Category
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th>
        <div class="vbox">
          Short Code
          <input [(ngModel)]="filter.shortCode">
        </div>
      </th>
      <th>
        <div class="vbox">
          Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
      <th>
        <div class="vbox">
          Description
          <input [(ngModel)]="filter.description">
        </div>
      </th>
      <th>
        <div class="vbox">
          Assigned Users
        </div>
      </th>
      <th>
        <div class="vbox">
          Assigned Locks
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td>
        <a routerLink="/access/categories/{{element.id}}">{{element.shortCode}}</a>
      </td>
      <td>
        {{element.name}}
      </td>
      <td style="min-width: 600px">{{element.description | truncate: 100}}</td> <!-- Defaults to legacy all locks per site -->
      <td>{{element.userIds.length}}</td>
      <td>{{element.lockIds.length}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
